<script>
   /*************************************************************/
   /* Root component for the application                        */
   /*************************************************************/

   import App from '../../shared/components/MainApp.svelte';
   import TrainAppContainer from './tab_train/AppContainer.svelte';
   import TargetAppContainer from './tab_target/AppContainer.svelte';
   import AltAppContainer from './tab_new/AppContainer.svelte';
   import WASM from '../../shared/wasm/dist/pca_wasm.js';

   const containers = [
      {name: 'Train', container: TrainAppContainer},
      {name: 'Predict: Target', container: TargetAppContainer},
      {name: 'Predict: New', container: AltAppContainer},
   ]
</script>

<App appTitle="Data Driven SIMCA" appShortTitle="DD-SIMCA" isBeta={false} appSlogan="One class classifier" {WASM} {containers}>
   <div slot="footer">
      <p>Current release: <span>2.0.4</span>
      Feedback: <a class="paper-link" href="mailto:help@mda.tools?subject=DD-SIMCA app">help@mda.tools</a>
      Tutorial:
      <a href="https://doi.org/10.1002/cem.3556">paper</a>
      | <a class="paper-link" href="Oregano.zip" download>dataset</a>
      | <a href="https://www.youtube.com/playlist?list=PLep7KM9cEyFmoOR8sWDt7vJdnOCHvPEo2">video lessons</a>
      </p>
   </div>

   <h2>Data Driven SIMCA</h2>
   <p>Authors: <em>Sergey Kucheryavskiy, Oxana Rodionova, Alexey Pomerantsev</em></p>
   <p>
      Interactive web-application for creating and using DD-SIMCA one class classifier
      directly in your browser. The app does not send any information to a server,
      all calculations are done locally on your device.
   </p>
   <p>Check our open access <a href="https://doi.org/10.1002/cem.3556">tutorial paper</a> and YouTube <a href="https://www.youtube.com/playlist?list=PLep7KM9cEyFmoOR8sWDt7vJdnOCHvPEo2">video-lessons</a>
   <p>
      Related theory:
      <a href="https://doi.org/10.1002/cem.2506">10.1002/cem.2506</a>,
      <a href="https://doi.org/10.1002/cem.2610">10.1002/cem.2610</a>,
      <a href="https://doi.org/10.1002/cem.3250">10.1002/cem.3250</a>,
      <a href="https://doi.org/10.1016/j.aca.2024.343352">10.1016/j.aca.2024.343352</a>.
   </p>
   <h3>v. 2.0.x</h3>
   <p class="release-info">Small bug fixes and hidden improvements, last realease (2.0.4) from 10/11/2024</p>
   <h3>v. 2.0.2</h3>
   <p class="release-info">released 24/10/2024</p>
   <ul>
      <li>Major release, which adds several tools, such as selectivity, scores and loadings plots, as well as contains some minor improvements to plots. The theory behind selectivity concept can be found in <a href="https://doi.org/10.1016/j.aca.2024.343352">this paper</a>.</li>
      <li>Breaking changes —  the model structure created by the new version of the app is different as it also contains several new parameters. This means that the model objects created in the earlier version of the app can not be used to make predictions in the new version.</li>
      <li>Auto detection of CSV loading parameters when user just selects the file. Recognizes correct parameters in most of the cases.</li>
      <li>The old app version is available here: <a href="https://mda.tools/ddsimca-old/">https://mda.tools/ddsimca-old/</a>, so you can safely continue using it.</li>
      <li>All details about the new version can be found in <a href="https://youtu.be/pEITj9LvcTU?si=5T0JEy_dRGie2ZVH">this video</a></li>
   </ul>
   <p></p>
</App>
